// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".awsui_breadcrumbs-own_ete58_yonx9_5:not(#\\9 ):not(:empty)+.awsui_breadcrumbs-discovered_ete58_yonx9_5{display:none}", ""]);
// Exports
module.exports = exports;
